import React from "react";
import CloseButton from "../../../../../components/CloseButton";
import CustomCalendar from "./CustomCalendar";
import Switch from "@mui/material/Switch";

const DateSelectionPage = ({
  onClose,
  onClickNext,
  selectedDate,
  handleDateSelect,
  hideAfterClosed,
  setHideAfterClosed,
}) => {
  const handleSwitchChange = (event) => {
    setHideAfterClosed(event.target.checked);
  };

  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fff",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CloseButton onClick={onClose} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          fontSize: "24px",
          boxSizing: "border-box",
          padding: "25px 60px 15px 30px",
        }}
      >
        <span>마감일 선택</span>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "20px",
          }}
        >
          <span>마감일 후 삭제</span>
          <Switch
            checked={hideAfterClosed}
            onChange={handleSwitchChange}
            color="primary"
            sx={{
              transform: "scale(1.3)", // Adjust the scale factor to resize the switch
            }}
          />
        </div>
      </div>

      <CustomCalendar
        selectedDate={selectedDate}
        handleDateSelect={handleDateSelect}
      ></CustomCalendar>

      {/* 다음 버튼: Step2 → Step3 이동 */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginRight: "40px",
          marginBottom: "20px",
        }}
      >
        <button
          style={{
            marginTop: "auto", // 여백 확보
            padding: "5px 40px",
            backgroundColor: "#2D2D2D",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
          }}
          onClick={onClickNext}
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default DateSelectionPage;
